import { Injectable } from '@angular/core'
import { PatientInfo } from '@/app/shared/models/patient-info/patient-info.model'
import { BaseApiService, HttpOptions } from '@/app/shared/services/api/base-api.service'
import { Order } from '@/app/shared/models/order/order.model'
import { Observable } from 'rxjs'
import { PatchPatientInfoRequest } from '@/app/shared/models/patient-info/patch-patient-info-request.model'

@Injectable({
  providedIn: 'root'
})
export class PatientInfoApiService extends BaseApiService<PatientInfo> {
  protected readonly endpoint = 'api/patient_infos';

  patchPatientInfo(
    patientInfoId: number|string,
    patchPatientInfoRequest: PatchPatientInfoRequest,
    options: HttpOptions = {}
  ): Observable<Order> {
    const defaultHeaders = this.defaultHeadersForUpdate;
    const finalOptions = {
      headers: { ...defaultHeaders, ...options.headers },
      params: options.params
    };
    return this.httpClient.patch<Order>(`${this.endpoint}/${patientInfoId}`, patchPatientInfoRequest, finalOptions);
  }

  patchPatientInfoRavf(
    patientInfoId: number|string,
    referentAvfIri: string | null,
    options: HttpOptions = {}
  ): Observable<PatientInfo> {
    const defaultHeaders = this.defaultHeadersForUpdate;
    const finalOptions = {
      headers: { ...defaultHeaders, ...options.headers },
      params: options.params
    };
    return this.httpClient.patch<PatientInfo>(
      `${this.endpoint}/${patientInfoId}/ravf`,
      { referentAvf: referentAvfIri },
      finalOptions
    );
  }
}
